define('views/modals/messenger/index',['require','views/base/modal','views/modals/messenger/panel','views/modals/messenger/message-list','views/modals/messenger/footer'],function(require) {
    'use strict';

    var ModalView = require('views/base/modal'),
        MessengerPanelView = require('views/modals/messenger/panel'),
        MessengerMessageList = require('views/modals/messenger/message-list'),
        MessengerModalFooterView = require('views/modals/messenger/footer');

    var MessengerModalView = ModalView.extend({
        footerViewClass: MessengerModalFooterView,
        listen: {
        },
        id: 'messenger-modal',
        // animateClass: 'animate',
        initialize: function() {
            ModalView.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            ModalView.prototype.render.apply(this, arguments);

            this.subview('panel', new MessengerPanelView({ model: this.model.content }));
            this.subview('list', new MessengerMessageList({ collection: this.model.content.messages, model: this.model.content }));
        },
        action: function(action, cancel) {
            if (action === 'send') {
                this.model.sendMessage(this.$('textarea').val());
                this.$('textarea').val('');
                cancel();
            }
        }
    });

    return MessengerModalView;
});

